module.exports = __webpack_public_path__ + "static/media/Vector 441.f6a9b52c.svg";